import { useQuery } from "react-query";
import { getUser } from "../../../admin/user-roles/lib/userData";

export const useUserDetails = (id) => {
    return useQuery({
        queryKey: ["userDetails", id],
        queryFn: () => getUser(id),
    });
};
